import { render, staticRenderFns } from "./Sensoriamento.vue?vue&type=template&id=0b081e0d&scoped=true&"
import script from "./Sensoriamento.vue?vue&type=script&lang=js&"
export * from "./Sensoriamento.vue?vue&type=script&lang=js&"
import style0 from "./Sensoriamento.vue?vue&type=style&index=0&id=0b081e0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b081e0d",
  null
  
)

export default component.exports